<template>
  <div
    class="vote-input"
    :class="{'vote-input--selected': !!modelValue}"
  >
    <div class="vote-input__inputs">
      <label
        v-if="!voteOnce || (voteOnce && (!modelValue || modelValue === positiveValue))"
        class="vote-input__label vote-input__label--positive"
        :class="{
          'vote-input__label--checked': modelValue === positiveValue
        }"
        :key="`p`"
      >
        <input
          type="radio"
          class="vote-input__radio"
          :name="name"
          :value="positiveValue"
          :checked="modelValue === positiveValue"
          @change="$emit('update:modelValue', $event.target.value)"
        >
      </label>

      <label
        v-if="!voteOnce || (voteOnce && (!modelValue || modelValue === negativeValue))"
        class="vote-input__label vote-input__label--negative"
        :class="{
          'vote-input__label--checked': modelValue === negativeValue
        }"
        :key="`n`"
      >
        <input
          type="radio"
          class="vote-input__radio"
          :name="name"
          :value="negativeValue"
          :checked="modelValue === negativeValue"
          @change="$emit('update:modelValue', $event.target.value)"
        >
      </label>
    </div>

    <transition name="input-error--animation">
      <div
        class="vote-input__error | input-error"
        v-if="!!error"
        v-html="error"
      />
    </transition>
  </div>
</template>

<script lang="ts">
  import {Options, Prop, Vue} from 'vue-property-decorator';

  @Options({
    name: 'vote-input',
  })
  export default class VoteInput extends Vue {
    static positiveValue = 'positive';
    static negativeValue = 'negative';

    @Prop({default: null, validator: (val: string) => [null, '', VoteInput.positiveValue, VoteInput.negativeValue].indexOf(val) !== -1})
    modelValue: string|null;

    @Prop({default: 'vote'})
    name: string;

    @Prop({default: false})
    voteOnce: boolean;

    @Prop()
    error: string;

    positiveValue = VoteInput.positiveValue;
    negativeValue = VoteInput.negativeValue;
  }
</script>
